import { render } from "./UpdateBillingModal.vue?vue&type=template&id=cd264b30"
import script from "./UpdateBillingModal.vue?vue&type=script&lang=ts"
export * from "./UpdateBillingModal.vue?vue&type=script&lang=ts"
script.render = render

export default script